import React from "react";
import "./App.css";

// Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";

// React Router
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Auth
import { AuthProvider } from "./auth/AuthContext";
import ProtectedRoute from "./auth/ProtectedRoute";

// Pages
import Home from "./Home/Home.js";
import LoginPage from "./LoginRegister/LoginPage.js";
import RegisterPage from "./LoginRegister/RegisterPage.js";
import ForgotPasswordPage from "./LoginRegister/ForgotPasswordPage.js";
// import CardiacBP from "./CardiacBP/CardiacBP.js";
// import CardioCareDashboard from "./CardiocareDashboard/pages/dashboard.js";
// import PatientProfile from "./CardiocareDashboard/PatientProfile.js";
import PatientHub from "./PatientHub/pages/patienthub.js";

// Admin Pages
// import AdminDashboardChoice from "./AdminDashboard/AdminDashboard.js";
// import AdminPage from "./AdminDashboard/AdminPage.js";

// FutureLynk Dashboard
import Dashboard from "./FutureLynkDashboard/pages/Dashboard.js";
import UserAnalytics from "./analyticsDashboard/pages/useranalytics.js";

// carecoordinator 
import CCHome from "./CareCoordinator/pages/CCHome";
import ProgramOverview from "./CareCoordinator/pages/ProgramOverview";
import PatientDetail from "./CareCoordinator/pages/PatientDetail";
import InquiryRegistration from "./CareCoordinator/components/Inquiryregistration.js";

//carecoordinator's admin
import CareCoordinatorList from "./CareCoordinator/pages/carecoordinatorlist";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Router>
          <Routes>

            {/* Home — public */}
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />

            {/* Authentication — public */}
            <Route path="/caretaker-login" element={<LoginPage />} />
            <Route path="/caretaker-registration" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />

            {/* After Caretaker Login — protected */}
            {/* <Route path="/cardiac-bp-choice" element={
              <ProtectedRoute><CardiacBP /></ProtectedRoute>
            } /> */}

            {/* Dashboards in use — protected */}
            <Route path="/futurelynk" element={<Dashboard />} />
            
            <Route path="/patienthub" element={
              <ProtectedRoute><PatientHub /></ProtectedRoute>
            } />
            <Route path="/care-coordinator" element={
              <ProtectedRoute><CCHome /></ProtectedRoute>
            } />
            <Route path="/care-coordinator/program" element={
              <ProtectedRoute><ProgramOverview /></ProtectedRoute>
            } />
            <Route path="/care-coordinator/inquiry" element={
              <ProtectedRoute><InquiryRegistration /></ProtectedRoute>
            } />
            <Route path="/care-coordinator/patient/:id" element={
              <ProtectedRoute><PatientDetail /></ProtectedRoute>
            } />
            <Route path="/user-analytics" element={
              <ProtectedRoute><UserAnalytics /></ProtectedRoute>
            } />

            {/* Super Admin: list all care coordinators — protected */}
            <Route path="/admin/care-coordinators" element={
              <ProtectedRoute><CareCoordinatorList /></ProtectedRoute>
            } />

            {/* Dashboards not in use — protected */}
            {/* <Route path="/cardio-care-dashboard" element={
              <ProtectedRoute><CardioCareDashboard /></ProtectedRoute>
            } /> */}

            {/* Admin Routes — protected */}
            {/* <Route path="/admin-service-choice" element={
              <ProtectedRoute><AdminDashboardChoice /></ProtectedRoute>
            } /> */}
            {/* <Route path="/admin-cardio-panel" element={
              <ProtectedRoute><AdminPage /></ProtectedRoute>
            } /> */}

            {/* Patient Profile — protected */}
            {/* <Route path="/patient/:patientFid" element={
              <ProtectedRoute><PatientProfile /></ProtectedRoute>
            } /> */}

          </Routes>
        </Router>
      </AuthProvider>
    </div>
  );
}

export default App;